import React from "react";

import { SupplementsContext } from "./SupplementsContext";
import { useSupplementsContext } from "./useSupplementsContext";

export const SupplementsProvider: React.FC = ({ children }) => {
  const value = useSupplementsContext();

  return <SupplementsContext.Provider value={value}>{children}</SupplementsContext.Provider>;
};
